import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PostHogProvider } from '@posthog/react';
import { initPosthog, posthog } from 'config/posthog';
import { selectIsPosthogWebEnabled } from 'common/features/store/duck/ffs';
import { useRootSelector } from 'common/features/featuresReducer';
import { selectIsAuthenticated } from 'common/features/store/duck/account/duck';
import packageJson from '../../../package.json';
import { isPaymentHost } from 'utils';

/**
 * Gates PostHog initialization and provider on:
 * - enable_posthog_web: feature flag (authenticated) OR Firebase Remote Config (unauthenticated)
 * - Not on payment host
 * Org enrollment is a public flow, so we can't rely on CRM feature
 * flags (which require auth tokens) to initialize PostHog.
 */
export const PostHogGate = ({ children }: { children: React.ReactNode }) => {
    const [phInitialized, setPhInitialized] = useState(false);
    const isAuthenticated = useRootSelector(selectIsAuthenticated);

    const isPosthogWebEnabled = useSelector(selectIsPosthogWebEnabled);

    useEffect(() => {
        if (isPaymentHost()) {
            return;
        }

        const shouldInitPosthog = isPosthogWebEnabled || !isAuthenticated;

        if (!phInitialized && shouldInitPosthog) {
            const client = initPosthog(packageJson.version);
            if (client) {
                setPhInitialized(true);
            }
        }
    }, [isPosthogWebEnabled, isAuthenticated]);

    if (!phInitialized) {
        return <>{children}</>;
    }

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
